import React, { FC } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface Props {
  open: boolean;
  title: string | null;
  images: string[] | null;
  isLoading: boolean;
  onClose: () => void;
}

const TemplatePreviewDialog: FC<Props> = ({
  open,
  title,
  images,
  isLoading,
  onClose,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      {isLoading ? (
        <DialogContentText>Loading preview...</DialogContentText>
      ) : images && images.length > 0 ? (
        images.map((src) => (
          <img
            key={src}
            src={src}
            alt=""
            style={{ width: '100%', marginBottom: 8, display: 'block' }}
          />
        ))
      ) : (
        <DialogContentText>
          No preview pages available for this document.
        </DialogContentText>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="contained">
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default TemplatePreviewDialog;
